var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errors"},[_c('div',_vm._l((_vm.getFeeds),function(err,i){return _c('v-alert',{key:i,attrs:{"color":err.type === 'E' ? 'red' : 'green',"type":err.type === 'E' ? 'error' : 'success'}},[_vm._v(" "+_vm._s(err.alert)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }